(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumb-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const breadcrumbContent = document.querySelector('.breadcrum ul');
  const container = document.querySelector('.breadcrumbs');

  // ISO Banner'ı breadcrumbs içine ekle (container dışında)
  if (container) {
    const isoBanner = document.createElement('div');
    isoBanner.className = 'iso-banner';
    isoBanner.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0251/6146/5961/files/image_153.png?v=1750695922" alt="ISO 10002 Shield" class="iso-shield">
      <div class="iso-content">
        <h2>ISO 10002 Sertifikalı Müşteri Memnuniyeti Sistemi</h2>
        <p>KolayOto, müşteri memnuniyeti süreçlerinde ulusalararesi <b>ISO 10002</b> kalite standardına sahiptir. Son 30 gün içinde <b>25.000+</b> yorum ve <b>4.56/5</b> puanla hizmet kalitemizi kanıtladık.</p>
      </div>
      <img src="https://cdn.shopify.com/s/files/1/0251/6146/5961/files/image_154.png?v=1750695921" alt="ISO Logo" class="iso-logo">
    `;
    container.appendChild(isoBanner);
  }

  function checkOverflow() {
    if (!breadcrumbContent || !container) return;

    const containerWidth = container.offsetWidth;
    const contentWidth = breadcrumbContent.scrollWidth;

    if (contentWidth > containerWidth) {
      breadcrumbContent.classList.add('animate');
    } else {
      breadcrumbContent.classList.remove('animate');
    }
  }

  checkOverflow();
  window.addEventListener('resize', checkOverflow);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrumb"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const breadcrumbContent = document.querySelector('.breadcrum ul');
  const container = document.querySelector('.breadcrumbs');

  function checkOverflow() {
    if (!breadcrumbContent || !container) return;

    const containerWidth = container.offsetWidth;
    const contentWidth = breadcrumbContent.scrollWidth;

    // Eğer içerik container genişliğini aşıyorsa animasyonu başlat
    if (contentWidth > containerWidth) {
      breadcrumbContent.classList.add('animate');
    } else {
      breadcrumbContent.classList.remove('animate');
    }
  }

  // Sayfada yüklenirken ve pencere yeniden boyutlandırıldığında kontrol et
  checkOverflow();
  window.addEventListener('resize', checkOverflow);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Taksit fiyatı güncelleme fonksiyonu
  function updateTaksitPrice() {
    const priceElement = document.getElementById('js-product-price');
    if (!priceElement) return;

    // Fiyat metnini al ve sadece sayısal değeri çıkar (örn: "6.936 TL" -> 6936)
    const priceText = priceElement.textContent.trim();
    const price = parseFloat(priceText.replace(/[^0-9,\.]/g, '').replace(',', '.')) * 1000;
    
    // Taksit hesapla (fiyatı 3'e böl)
    const taksitPrice = (price / 3).toFixed(2);
    
    const taksitPriceElement = document.querySelector('.js-taksit-price');
    if (taksitPriceElement) {
      taksitPriceElement.textContent = taksitPrice + '₺';
    }
  }

  // İlk yüklemede taksit fiyatını hesapla
  updateTaksitPrice();

  // Varyant seçimi için tıklamaları dinle
  document.addEventListener('click', function(event) {
    if (event.target.closest('.product-options__value')) {
      // Varyant seçildikten sonra kısa bir gecikme ile fiyatı güncelle
      setTimeout(updateTaksitPrice, 100);
    }
  });

  // Fiyat değişikliklerini izle (ek güvenlik için)
  const priceElement = document.getElementById('js-product-price');
  if (priceElement) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function() {
        updateTaksitPrice();
      });
    });

    observer.observe(priceElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product-carousel"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    
    const productRecommendationsSection = entries[0].target;
    observer.unobserve(productRecommendationsSection);
    
    const hasLiquidProducts = productRecommendationsSection.dataset.hasLiquidProducts === 'true';
    
    // Liquid'de ürünler varsa direkt carousel'i initialize et
    const existingCarousel = productRecommendationsSection.querySelector('.js_carousel');
    if (existingCarousel && existingCarousel.querySelectorAll('.alo-item').length > 0) {
      console.log('Related Products - Products found in Liquid, initializing carousel');
      hideLoading(productRecommendationsSection);
      initializeCarousel(productRecommendationsSection);
      return;
    }
    
    if (!hasLiquidProducts) {
      console.log('Related Products - No Liquid products, loading default recommendations');
      loadDefaultRecommendations(productRecommendationsSection);
      return;
    }
    
    // Eğer Liquid'de ürün yoksa eski sistemi kullan
    const currentProductId = parseInt(productRecommendationsSection.dataset.productId);
    const width = parseInt(productRecommendationsSection.dataset.width);
    const aspect = parseInt(productRecommendationsSection.dataset.aspect);
    const diameter = parseInt(productRecommendationsSection.dataset.diameter);
    const currentBrand = (productRecommendationsSection.dataset.brand || '').toLowerCase().trim();
    const maxCount = parseInt(productRecommendationsSection.dataset.maxCount) || 6;
    
    if (!width || !aspect || !diameter) {
      console.log('Related Products - No size info, using default recommendations');
      loadDefaultRecommendations(productRecommendationsSection);
      return;
    }
    
    findProductsBySize(width, aspect, diameter, currentBrand, currentProductId, maxCount, productRecommendationsSection);
  };
    
    // HTML'den ürün bilgilerini parse eden yardımcı fonksiyon
    function parseProductFromHTML(product, html) {
      // Product ID'yi bul
      const productIdMatch = html.match(/data-product-id="(\d+)"/) || 
                             html.match(/"product_id":(\d+)/) ||
                             html.match(/\/products\/[^\/]+\?variant=(\d+)/);
      const productId = productIdMatch ? parseInt(productIdMatch[1]) : (product.id || null);
      
      // Metafield bilgilerini çıkar
      const metafields = { filtre: {} };
      
      // Script tag'lerinden JSON data çıkar (data-json-product)
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const scriptTags = doc.querySelectorAll('script.data-json-product[type="application/json"]');
      
      scriptTags.forEach(script => {
        try {
          const jsonText = script.textContent.trim();
          if (jsonText) {
            const jsonData = JSON.parse(jsonText);
            if (jsonData.metafields && jsonData.metafields.filtre) {
              Object.assign(metafields.filtre, jsonData.metafields.filtre);
            }
          }
        } catch(e) {
          // Ignore parse errors
        }
      });
      
      // Product title
      const titleMatch = html.match(/<h1[^>]*>([^<]+)<\/h1>/) ||
                        html.match(/<title>([^<]+)<\/title>/);
      const title = titleMatch ? titleMatch[1].trim() : (product.title || '');
      
      // Product type
      const typeMatch = html.match(/product\.type[^=]*=\s*["']([^"']+)["']/) ||
                         html.match(/"type"\s*:\s*"([^"]+)"/);
      const productType = typeMatch ? typeMatch[1].trim().toLowerCase() : (product.type || '').toLowerCase();
      
      return {
        id: productId,
        handle: product.handle,
        title: title,
        type: productType,
        metafields: metafields
      };
    }
    
    function findProductsBySize(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container) {
      // Ebat formatlarını al
      const sizeFormat1 = container.dataset.sizeFormat1 || '';
      const sizeFormat2 = container.dataset.sizeFormat2 || '';
      const sizeFormat3 = container.dataset.sizeFormat3 || '';
      const matchingCollections = (container.dataset.matchingCollections || '').split(',').filter(c => c.trim());
      
      console.log('Related Products - Size formats:', {
        format1: sizeFormat1,
        format2: sizeFormat2,
        format3: sizeFormat3,
        matchingCollections: matchingCollections
      });
      
    // Eğer ebat içeren koleksiyon bulunduysa, o koleksiyonlardan ürünleri çek
    if (matchingCollections.length > 0) {
      console.log('Related Products - Found matching collections:', matchingCollections);
      
      // Tüm eşleşen koleksiyonlardan ürünleri çek
      const collectionPromises = matchingCollections.map(collectionHandle => {
        return fetch('/collections/' + collectionHandle + '/products.json?limit=250')
          .then(response => response.ok ? response.json() : null)
          .then(data => {
            if (data && data.products) {
              return data.products.map(p => ({
                id: p.id,
                handle: p.handle,
                title: p.title,
                vendor: p.vendor,
                type: p.product_type
              }));
            }
            return [];
          })
          .catch(() => []);
      });
      
      return Promise.all(collectionPromises)
        .then(collectionsProducts => {
          // Tüm koleksiyonlardan gelen ürünleri birleştir ve duplicate'leri kaldır
          const allProducts = [];
          const seenIds = {};
          
          collectionsProducts.forEach(products => {
            products.forEach(product => {
              if (!seenIds[product.id] && product.id !== excludeProductId) {
                seenIds[product.id] = true;
                allProducts.push(product);
              }
            });
          });
          
          console.log('Related Products - Found products from collections:', allProducts.length);
          
          // Her ürünün detaylarını çek (metafield'lar için)
          const productPromises = allProducts.slice(0, 50).map(product => {
            return fetch('/products/' + product.handle)
              .then(response => response.ok ? response.text() : null)
              .then(html => html ? parseProductFromHTML(product, html) : null)
              .catch(() => null);
          });
          
          return Promise.all(productPromises)
            .then(products => {
              // Koleksiyonlardan gelen ürünleri direkt render et - hiçbir filtreleme yok, maksimum 10 ürün
              products = products.filter(p => p !== null); // Sadece null'ları temizle
              console.log('Related Products - Rendering products directly (no filtering):', products.length);
              
              const maxDisplay = 10;
              const limitedProducts = products.slice(0, maxDisplay);
              if (limitedProducts.length === 0) {
                console.log('Related Products - No products to render, loading default recommendations');
                loadDefaultRecommendations(container);
              } else {
                renderProducts(limitedProducts, container);
              }
            });
        });
    }
    
    // Eğer ebat içeren koleksiyon bulunamadıysa, fallback kullan
    console.log('Related Products - No matching collections found, loading default recommendations');
    loadDefaultRecommendations(container);
    return;
  }
    
    // Ürünleri filtreleyen yardımcı fonksiyon (ebat ve marka kontrolü yok - koleksiyon zaten ebat içeriyor, tüm markalar gelebilir)
    function filterProductsBySize(products, width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container) {
      if (!products || products.length === 0) {
        return fetchAllProductsAndFilter(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container);
      }
      
      // Filtrele: sadece mevcut ürünü hariç tut (ebat ve marka kontrolü yok - koleksiyon zaten ebat içeriyor, tüm markalar gelebilir)
      console.log('Related Products - Filtering products (only exclude current product, size already matched by collection). Looking for:', {
        excludeProductId: excludeProductId
      });
      
      const filtered = products.filter(product => {
        if (!product || product.id === excludeProductId) {
          return false;
        }
        
        // Product type kontrolü - sadece lastik ürünleri
        const productType = (product.type || '').toLowerCase().trim();
        if (productType && !productType.includes('lastik')) {
          return false;
        }
        
        // Tüm ürünleri kabul et (marka kontrolü yok)
        return true;
      });
      
      console.log('Related Products - Filtered products:', filtered.length, 'from', products.length);
      
      // Limit'e göre al ve render et - maksimum 10 ürün
      const maxDisplay = 10;
      const limitedProducts = filtered.slice(0, maxDisplay);
      if (limitedProducts.length === 0) {
        console.log('Related Products - No matching products found, loading default recommendations');
        loadDefaultRecommendations(container);
      } else {
        renderProducts(limitedProducts, container);
      }
    }
    
    function findProductsBySizeOldMethod(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container) {
      // Eski yöntem: Collection filter kullan (fallback)
      const filterUrl = '/collections/all?filter.p.m.filtre.taban_genisligi=' + width + 
                        '&filter.p.m.filtre.kesit_orani=' + aspect + 
                        '&filter.p.m.filtre.jant_capi=' + diameter + 
                        '&filter.v.availability=1';
      
      console.log('Related Products - Using old filter method:', filterUrl);
      
      return fetch(filterUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productLinks = doc.querySelectorAll('a[href*="/products/"]');
          const productHandles = [];
          const seenHandles = {};
          
          productLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href) {
              const match = href.match(/\/products\/([^\/\?&#]+)/);
              if (match && match[1] && !seenHandles[match[1]]) {
                productHandles.push(match[1]);
                seenHandles[match[1]] = true;
              }
            }
          });
          
          console.log('Related Products - Found product handles from collection filter:', productHandles.length);
          
          // Eğer filtered collection'dan ürün bulamazsak veya çok az ürün varsa, fallback kullan
          if (productHandles.length === 0 || productHandles.length < 5) {
            console.log('Related Products - Collection filter returned insufficient products, using fallback');
            return fetchAllProductsAndFilter(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container);
          }
          
          // Collection filter'dan gelen ürünlerin detaylarını çek
          // Product type ve metafield kontrolü yapacağız
          const productPromises = productHandles.slice(0, 50).map(handle => {
            return fetch('/products/' + handle)
              .then(response => response.ok ? response.text() : null)
              .then(html => html ? parseProductFromHTML({ handle: handle }, html) : null)
              .catch(() => null);
          });
          
          return Promise.all(productPromises);
        })
        .then(products => {
          if (!products || products.length === 0) {
            return fetchAllProductsAndFilter(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container);
          }
          
          // Filtrele: aynı ebat, farklı marka, mevcut ürün hariç
          console.log('Related Products - Filtering products. Looking for:', {
            width: width,
            aspect: aspect,
            diameter: diameter,
            excludeBrand: excludeBrand,
            excludeProductId: excludeProductId
          });
          
          const filtered = products.filter(product => {
            if (!product || product.id === excludeProductId) {
              if (!product) console.log('  - Product is null');
              if (product && product.id === excludeProductId) console.log('  - Product ID matches current:', product.id);
              return false;
            }
            
            // Product type kontrolü - sadece lastik ürünleri
            const productType = (product.type || '').toLowerCase().trim();
            if (productType && !productType.includes('lastik')) {
              if (products.indexOf(product) < 3) {
                console.log('  - Product is not a tire:', product.handle, 'Type:', productType);
              }
              return false;
            }
            
            const productWidth = getMetafieldValue(product, 'filtre', 'taban_genisligi');
            const productAspect = getMetafieldValue(product, 'filtre', 'kesit_orani');
            const productDiameter = getMetafieldValue(product, 'filtre', 'jant_capi');
            const productBrand = getMetafieldValue(product, 'filtre', 'marka', true);
            const productBrandLower = productBrand ? productBrand.toLowerCase().trim() : '';
            
            // Debug: İlk birkaç ürünü detaylı logla
            if (products.indexOf(product) < 3) {
              console.log('Related Products - Sample product:', {
                id: product.id,
                handle: product.handle,
                title: product.title,
                type: productType,
                metafields: product.metafields,
                width: productWidth,
                aspect: productAspect,
                diameter: productDiameter,
                brand: productBrandLower
              });
            }
            
            // Ebat eşleşmesi kontrolü - strict equality
            const sizeMatch = productWidth === width && productAspect === aspect && productDiameter === diameter;
            
            // Marka farklı olmalı (veya marka bilgisi yoksa göster)
            const brandDifferent = !productBrandLower || productBrandLower !== excludeBrand;
            
            // Debug: İlk birkaç ürün için detaylı kontrol
            if (products.indexOf(product) < 3) {
              console.log('  - Size match check:', {
                productWidth: productWidth, '===': width, match: productWidth === width,
                productAspect: productAspect, '===': aspect, match: productAspect === aspect,
                productDiameter: productDiameter, '===': diameter, match: productDiameter === diameter,
                sizeMatch: sizeMatch,
                brandDifferent: brandDifferent,
                finalMatch: sizeMatch && brandDifferent
              });
            }
            
            if (sizeMatch && !brandDifferent) {
              console.log('  - Product matched size but same brand:', product.handle, productBrandLower);
            }
            
            return sizeMatch && brandDifferent;
          });
          
        console.log('Related Products - Filtered products:', filtered.length, 'from', products.length);
        
        // Limit'e göre al ve render et - maksimum 10 ürün
        const maxDisplay = 10;
        const limitedProducts = filtered.slice(0, maxDisplay);
        if (limitedProducts.length === 0) {
          console.log('Related Products - No matching products found, loading default recommendations');
          loadDefaultRecommendations(container);
        } else {
          renderProducts(limitedProducts, container);
        }
        })
        .catch(error => {
          console.error('Error fetching products:', error);
          // Fallback: tüm ürünleri çekip filtrele
          fetchAllProductsAndFilter(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container);
        });
    }
    
    function fetchAllProductsAndFilter(width, aspect, diameter, excludeBrand, excludeProductId, maxCount, container) {
      // Tüm ürünleri products.json'dan çek (limit 250)
      fetch('/collections/all/products.json?limit=250')
        .then(response => response.json())
        .then(data => {
          if (!data || !data.products || data.products.length === 0) {
            hideLoading(container);
            return;
          }
          
          // Her ürünün HTML'den metafield bilgilerini çek
          const productPromises = data.products.slice(0, 100).map(product => {
            return fetch('/products/' + product.handle)
              .then(response => response.ok ? response.text() : null)
              .then(html => {
                if (!html) return { id: product.id, handle: product.handle, title: product.title, metafields: {} };
                
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const metafields = {};
                
                // Script tag'lerinden JSON data çıkar
                const scriptTags = doc.querySelectorAll('script[type="application/json"]');
                scriptTags.forEach(script => {
                  try {
                    const jsonData = JSON.parse(script.textContent);
                    if (jsonData.metafields) {
                      Object.assign(metafields, jsonData.metafields);
                    }
                  } catch(e) {
                    // Ignore
                  }
                });
                
                // Hidden element'lerden metafield bilgilerini çıkar
                const hiddenMetafields = doc.querySelectorAll('.hidden span[id*="metafield"], [data-metafield]');
                hiddenMetafields.forEach(el => {
                  const id = el.id || '';
                  if (id.includes('taban_genisligi')) {
                    if (!metafields.filtre) metafields.filtre = {};
                    metafields.filtre.taban_genisligi = parseInt(el.textContent.trim()) || null;
                  } else if (id.includes('kesit_orani')) {
                    if (!metafields.filtre) metafields.filtre = {};
                    metafields.filtre.kesit_orani = parseInt(el.textContent.trim()) || null;
                  } else if (id.includes('jant_capi')) {
                    if (!metafields.filtre) metafields.filtre = {};
                    metafields.filtre.jant_capi = parseInt(el.textContent.trim()) || null;
                  } else if (id.includes('marka')) {
                    if (!metafields.filtre) metafields.filtre = {};
                    metafields.filtre.marka = el.textContent.trim();
                  }
                });
                
                return {
                  id: product.id,
                  handle: product.handle,
                  title: product.title,
                  metafields: metafields
                };
              })
              .catch(() => ({ id: product.id, handle: product.handle, title: product.title, metafields: {} }));
          });
          
          return Promise.all(productPromises);
        })
        .then(products => {
          if (!products) {
            hideLoading(container);
            return;
          }
          
          // Filtrele
          console.log('Related Products - Fallback filtering. Looking for:', {
            width: width,
            aspect: aspect,
            diameter: diameter,
            excludeBrand: excludeBrand
          });
          
          const filtered = products.filter(product => {
            if (!product || product.id === excludeProductId) return false;
            
            const productWidth = getMetafieldValue(product, 'filtre', 'taban_genisligi');
            const productAspect = getMetafieldValue(product, 'filtre', 'kesit_orani');
            const productDiameter = getMetafieldValue(product, 'filtre', 'jant_capi');
            const productBrand = getMetafieldValue(product, 'filtre', 'marka', true);
            const productBrandLower = productBrand ? productBrand.toLowerCase().trim() : '';
            
            // Debug ilk birkaç ürün
            if (products.indexOf(product) < 3) {
              console.log('Related Products - Fallback sample product:', {
                id: product.id,
                handle: product.handle,
                width: productWidth,
                aspect: productAspect,
                diameter: productDiameter,
                brand: productBrandLower,
                metafields: product.metafields
              });
            }
            
            const sizeMatch = productWidth === width && productAspect === aspect && productDiameter === diameter;
            const brandDifferent = !productBrandLower || productBrandLower !== excludeBrand;
            
            return sizeMatch && brandDifferent;
          });
          
          console.log('Related Products - Fallback filtered:', filtered.length, 'from', products.length);
          
          const limitedProducts = filtered.slice(0, maxCount);
          if (limitedProducts.length === 0) {
            console.log('Related Products - No matching products found in fallback, loading default recommendations');
            loadDefaultRecommendations(container);
          } else {
            renderProducts(limitedProducts, container);
          }
        })
        .catch(error => {
          console.error('Error in fallback:', error);
          hideLoading(container);
        });
    }
    
    function getMetafieldValue(product, namespace, key, returnString) {
      if (!product.metafields) {
        return null;
      }
      
      returnString = returnString || false;
      
      // Farklı metafield formatlarını kontrol et
      // Format 1: product.metafields.filtre.taban_genisligi
      if (product.metafields[namespace] && product.metafields[namespace][key] !== undefined) {
        const value = product.metafields[namespace][key];
        if (returnString) {
          return String(value && value.value ? value.value : (value || ''));
        }
        const numValue = value && value.value ? value.value : value;
        const parsed = parseInt(numValue);
        return isNaN(parsed) ? null : parsed;
      }
      
      // Format 2: product.metafields['filtre.taban_genisligi']
      const dotKey = namespace + '.' + key;
      if (product.metafields[dotKey] !== undefined) {
        const value = product.metafields[dotKey];
        if (returnString) {
          return String(value && value.value ? value.value : (value || ''));
        }
        const numValue = value && value.value ? value.value : value;
        const parsed = parseInt(numValue);
        return isNaN(parsed) ? null : parsed;
      }
      
      // Format 3: Array format
      if (Array.isArray(product.metafields)) {
        const meta = product.metafields.find(m => 
          (m.namespace === namespace && m.key === key) || 
          m.key === dotKey
        );
        if (meta && meta.value !== undefined) {
          if (returnString) {
            return String(meta.value || '');
          }
          const parsed = parseInt(meta.value);
          return isNaN(parsed) ? null : parsed;
        }
      }
      
      // Format 4: Nested object (metafields.filtre.taban_genisligi.value)
      try {
        const nested = product.metafields[namespace] && product.metafields[namespace][key];
        if (nested !== undefined) {
          const value = nested.value !== undefined ? nested.value : nested;
          if (returnString) {
            return String(value || '');
          }
          const parsed = parseInt(value);
          return isNaN(parsed) ? null : parsed;
        }
      } catch(e) {
        // Ignore
      }
      
      return null;
    }
    
    function renderProducts(products, container) {
      if (!products || products.length === 0) {
        hideLoading(container);
        hideSection(container);
        return;
      }
      
      const loadingDiv = container.querySelector('.recommendations-loading');
      if (loadingDiv) loadingDiv.style.display = 'none';
      
      console.log('Related Products - Rendering products:', products.length);
      
      // Grid slider HTML'ini oluştur
      const sectionId = container.dataset.sectionId;
      const sid = container.dataset.sid;
      const spacing = container.dataset.spacing;
      
      // Grid slider attribute'larını oluştur
      const useSlider = container.dataset.useSlider === 'true';
      const gridSliderAttrs = buildGridSliderAttrs(container, sectionId);
      
      // Root URL'i al
      const rootPath = container.dataset.rootUrl || '';
      
      let html = '<div class="content_section slick-carousel">';
      html += '<div class="grid-slider row js_carousel" ' + gridSliderAttrs + 
              ' data-mobile="' + container.dataset.mobile + '"' +
              ' data-portrait="' + container.dataset.portrait + '"' +
              ' data-landscape="' + container.dataset.landscape + '"' +
              ' data-tablet="' + container.dataset.tablet + '"' +
              ' data-notebook="' + container.dataset.notebook + '"' +
              ' data-laptop="' + container.dataset.laptop + '"' +
              ' data-desktop="' + container.dataset.desktop + '"' +
              ' data-widescreen="' + container.dataset.widescreen + '"' +
              ' data-visible="' + container.dataset.visible + '"' +
              ' data-spacing="' + spacing + '"' +
              ' data-append-Arrows=".arrows_' + sid + '"' +
              ' data-append-Dots=".dots_' + sid + '"' +
              ' style="--perload-gap: ' + spacing + 'px">';
      
      products.forEach(product => {
        const url = rootPath + '/products/' + product.handle;
        html += '<div data-lazy-product-load class="productLazyload product-item lazyload" data-include="' + url + '/?view=pr_lazy_load">';
        html += '<div class="product-loading">Loading...</div>';
        html += '</div>';
      });
      
      html += '</div>';
      
      if (container.dataset.dots === 'true') {
        html += '<div class="laber_append_dots dots_' + sid + '"></div>';
      }
      
      if (container.dataset.arrows === 'true') {
        html += '<div class="laber_append_arrows arrows_' + sid + '"></div>';
      }
      
      html += '</div>';
      
      container.innerHTML = html;
      
      // Lazy load mekanizması için event listener ekle
      // jquery.interact-function.js tarafından handle edilecek
      setTimeout(() => {
        // Lazy load'ı tetikle
        if (typeof jQuery !== 'undefined') {
          const lazyItems = jQuery(container).find('[data-lazy-product-load]');
          if (lazyItems.length > 0) {
            // Lazy load library'nin çalışması için trigger et
            if (typeof window.lazyload !== 'undefined') {
              window.lazyload.update();
            }
            // Veya direkt fetch yap
            lazyItems.each(function() {
              const item = this;
              const url = item.getAttribute('data-include');
              if (url && !item.classList.contains('lazyloaded')) {
                fetch(url)
                  .then(response => response.text())
                  .then(html => {
                    item.innerHTML = html;
                    item.classList.add('lazyloaded');
                    item.classList.remove('lazyload');
                    // Lazy loaded event'i trigger et
                    if (typeof jQuery !== 'undefined') {
                      jQuery(item).trigger('lazyloaded');
                    }
                  })
                  .catch(() => {
                    item.innerHTML = '<div class="product-error">Product not found</div>';
                  });
              }
            });
          }
        }
        
        // Carousel'ı initialize et
        initializeCarousel(container);
      }, 100);
    }
    
    function initializeCarousel(container) {
      const carousel = container.querySelector('.js_carousel');
      if (!carousel) return;
      
      // jQuery ve Slick kontrolü
      if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
        console.error('Related Products - jQuery or Slick not found');
        return;
      }
      
      const $carousel = jQuery(carousel);
      
      // Eğer zaten initialize edilmişse refresh yap
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('refresh');
        return;
      }
      
      // Slider ayarlarını oku
      const useSlider = container.dataset.useSlider === 'true';
      if (!useSlider) {
        console.log('Related Products - Slider disabled');
        return;
      }
      
      // Slick carousel ayarları
      const slickOptions = {
        slidesToShow: parseInt(container.dataset.visible) || 5,
        slidesToScroll: parseInt(container.dataset.slidesToScroll) || 1,
        autoplay: container.dataset.autoplay === 'true',
        autoplaySpeed: parseInt(container.dataset.autoplaySpeed) || 3000,
        arrows: container.dataset.arrows === 'true',
        dots: container.dataset.dots === 'true',
        infinite: container.dataset.infinite === 'true',
        speed: parseInt(container.dataset.speed) || 300,
        swipe: true,
        touchMove: true,
        draggable: true,
        touchThreshold: 5,
        responsive: [
          { breakpoint: 1920, settings: { slidesToShow: parseInt(container.dataset.widescreen) || 4 } },
          { breakpoint: 1480, settings: { slidesToShow: parseInt(container.dataset.desktop) || 4 } },
          { breakpoint: 1200, settings: { slidesToShow: parseInt(container.dataset.laptop) || 4 } },
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 576, settings: { slidesToShow: 1 } }
        ]
      };
      
      // Slider'ı başlat
      setTimeout(() => {
        $carousel.slick(slickOptions);
        console.log('Related Products - Slick carousel initialized with touch support');
      }, 100);
    }
    
    function buildGridSliderAttrs(container, sectionId) {
      const useSlider = container.dataset.useSlider === 'true';
      let attrs = '';
      
      if (useSlider) {
        // Slick carousel ayarları
        const config = {
          'adaptive-Height': container.dataset.adaptiveHeight,
          'append-Arrows': '.arrows_' + container.dataset.sid,
          'append-Dots': '.dots_' + container.dataset.sid,
          'autoplay': container.dataset.autoplay === 'true',
          'autoplay-Speed': container.dataset.autoplaySpeed || '3000',
          'arrows': container.dataset.arrows === 'true',
          'center-Mode': container.dataset.centerMode === 'true',
          'dots': container.dataset.dots === 'true',
          'fade': container.dataset.fade === 'true',
          'infinite': container.dataset.infinite === 'true',
          'padding': container.dataset.spacing,
          'rows': container.dataset.rows || '1',
          'slides-To-Scroll': container.dataset.slidesToScroll || '1',
          'slides-To-Show': container.dataset.visible,
          'speed': container.dataset.speed || '300',
          'vertical': container.dataset.vertical === 'true',
          'vertical-Swiping': container.dataset.vertical === 'true'
        };
        
        for (const key in config) {
          const value = config[key];
          if (value !== null && value !== undefined && value !== '') {
            attrs += ' data-' + key + '="' + String(value).replace(/"/g, '&quot;') + '"';
          }
        }
        
        // Responsive breakpoints
        const responsive = [
          { breakpoint: 1921, slidesToShow: container.dataset.visible },
          { breakpoint: 1920, slidesToShow: container.dataset.widescreen },
          { breakpoint: 1480, slidesToShow: container.dataset.desktop },
          { breakpoint: 1200, slidesToShow: container.dataset.laptop },
          { breakpoint: 992, slidesToShow: 2 },
          { breakpoint: 768, slidesToShow: 2 },
          { breakpoint: 576, slidesToShow: 1 },
          { breakpoint: 481, slidesToShow: 1 },
          { breakpoint: 361, slidesToShow: 1 },
          { breakpoint: 1, slidesToShow: 1 }
        ];
        
        attrs += ' data-responsive=\'' + JSON.stringify(responsive).replace(/'/g, '&apos;') + '\'';
      } else {
        attrs += ' data-padding="' + container.dataset.spacing + '"';
      }
      
      attrs += ' data-wrapper="#shopify-section-' + sectionId + '"';
      
      return attrs;
    }
    
    function hideLoading(container) {
      const loadingDiv = container.querySelector('.recommendations-loading');
      if (loadingDiv) {
        loadingDiv.style.display = 'none';
      }
    }
    
    function hideSection(container) {
      // Section'ı bul (container'ın parent section'ı)
      let sectionElement = container.closest('section');
      if (!sectionElement) {
        // Eğer section bulunamazsa, container'ın en üst parent'ını bul
        sectionElement = container.closest('[id^="laber_"]') || container.closest('.laber_collection_related');
      }
      
      if (sectionElement) {
        console.log('Related Products - No products found, hiding entire section');
        sectionElement.style.display = 'none';
      } else {
        // Fallback: container'ın tüm parent container'ını gizle
        const sectionContent = container.closest('.section-content');
        if (sectionContent) {
          const productsArrivals = sectionContent.closest('.products-arrivals');
          if (productsArrivals) {
            productsArrivals.style.display = 'none';
          }
        }
      }
    }
    
    function loadDefaultRecommendations(container) {
      const recommendationsUrl = container.dataset.recommendationsUrl;
      if (!recommendationsUrl) {
        console.error('Related Products - Recommendations URL not found');
        hideLoading(container);
        hideSection(container);
        return;
      }
      
      console.log('Related Products - Loading default recommendations from:', recommendationsUrl);
      
      fetch(recommendationsUrl)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
          
          if (!recommendations) {
            console.log('Related Products - No recommendations found in response');
            hideLoading(container);
            hideSection(container);
            return;
          }
          
          // Shopify'ın öneriler HTML'inden ürün handle'larını çıkar
          const productLinks = recommendations.querySelectorAll('a[href*="/products/"]');
          const productHandles = [];
          
          productLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href) {
              const match = href.match(/\/products\/([^\/\?]+)/);
              if (match && match[1]) {
                const handle = match[1];
                if (!productHandles.includes(handle)) {
                  productHandles.push(handle);
                }
              }
            }
          });
          
          // Alternatif: data-js-product veya product-item içindeki linklerden handle çıkar
          if (productHandles.length === 0) {
            const productItems = recommendations.querySelectorAll('.product-item, .alo-item, [data-js-product]');
            productItems.forEach(item => {
              const link = item.querySelector('a[href*="/products/"]');
              if (link) {
                const href = link.getAttribute('href');
                const match = href.match(/\/products\/([^\/\?]+)/);
                if (match && match[1]) {
                  const handle = match[1];
                  if (!productHandles.includes(handle)) {
                    productHandles.push(handle);
                  }
                }
              }
            });
          }
          
          // Ürün handle'larını JSON formatında almak için script tag'lerinden çıkar
          if (productHandles.length === 0) {
            const scriptTags = recommendations.querySelectorAll('script[type="application/json"]');
            scriptTags.forEach(script => {
              try {
                const jsonData = JSON.parse(script.textContent);
                if (jsonData.handle) {
                  if (!productHandles.includes(jsonData.handle)) {
                    productHandles.push(jsonData.handle);
                  }
                }
              } catch(e) {
                // Ignore
              }
            });
          }
          
          console.log('Related Products - Found', productHandles.length, 'product handles:', productHandles);
          
          if (productHandles.length > 0) {
            // Ürünleri lazy load view ile render et
            const products = productHandles.map(handle => ({ handle: handle }));
            renderProducts(products, container);
          } else {
            // Eğer handle bulunamadıysa, orijinal HTML'i kullan (fallback)
            console.log('Related Products - No product handles found, using original HTML');
            container.innerHTML = recommendations.innerHTML;
            
            // Orijinal HTML'de ürün var mı kontrol et
            const hasProducts = container.querySelectorAll('.alo-item, .product-item, [data-js-product]');
            if (!hasProducts || hasProducts.length === 0) {
              console.log('Related Products - No products in original HTML either, hiding section');
              hideLoading(container);
              hideSection(container);
            } else {
              initializeCarousel(container);
            }
          }
        })
        .catch(e => {
          console.error('Product recommendations fetch error:', e);
          hideLoading(container);
          hideSection(container);
        });
    }
    
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection) {
      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 200px 0px'
      });
      
      observer.observe(productRecommendationsSection);
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
